import React, { useEffect, useState } from "react";
import { useBoolean, useInput } from "react-hanger";
import { connect } from "react-redux";
import styled from "styled-components";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import ErrorIcon from "@mui/icons-material/Error";
import LockIcon from "@mui/icons-material/Lock";
import {
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

import BundleCard from "../../../../bundleCard";
import { Emphasize, StrikeOut } from "../../../../styles";
import PoweredByStripeIcon from "../../../../../assets/images/Powered by Stripe - blurple.svg"
import { csActions } from "../../../../../redux/actions";

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PoweredByStripe = styled.img`
  height: 24px;
`;

const UnconnectedStep3Content = (props) => {
  const [selectedBundle, setSelectedBundle] = useState(props.selectedBundle || -1);
  const isPaymentDialogOpen = useBoolean(false);
  const stripe = useStripe();
  const elements = useElements();
  const [card, setCard] = useState(null);
  const isCardCompleted = useBoolean(false);
  const nameOnCard = useInput("");

  const handleSelectBundle = (index) => {
    setSelectedBundle(index);
  }

  const handleNextStep = () => {
    props.setBundle(props.orderId, props.bundles[selectedBundle].id, selectedBundle);
  }

  const handleCheckout = () => {
    props.chargeCard(props.visitorId, stripe, card, nameOnCard.value, props.orderId);
  }

  const handlePaymentDialogClose = () => {
    if (!props.isChargingCard)
      isPaymentDialogOpen.setFalse();
  }

  const onCardChange = (event) => {
    if (event.complete)
      isCardCompleted.setTrue();
    else
      isCardCompleted.setFalse();
  }

  useEffect(() => {
    if (props.order)
      props.handleNextStep();
  }, [props.order]);

  useEffect(() => {
    if (card) {
      if (props.isChargingCard)
        card.update({disabled: true});
      else
        card.update({disabled: false});
    }
  }, [card, props.isChargingCard]);

  useEffect(() => {
    if (props.selectedBundle >= 0)
      isPaymentDialogOpen.setTrue();
  }, [props.selectedBundle]);

  useEffect(() => {
    if (card) {
      card.update({
        hidePostalCode: true,
        style: {
          base: {
            color: "rgba(0, 0, 0, 0.87)",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            "::placeholder": {
              color: "rgba(0, 0, 0, 0.6)",
            },
            ":disabled": {
              color: "rgba(0, 0, 0, 0.38)",
            }
          },

        },
      });
      card.on("change", onCardChange);
    }
  }, [card]);

  useEffect(() => {
    if (elements)
      setCard(elements.getElement(CardElement));
  }, [elements]);

  useEffect(() => {
    props.unsetEmail();
    props.getBundles();
  }, []);

  return (
    <>
      {props.isGettingBundles &&
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress color="primary" />
        </Box>
      }
      {!props.isGettingBundles && props.bundles &&
        <Container
          sx={{
            padding: "0 !important",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "20px",
            width: "100%",
          }}
        >
          {props.bundles.map((bundle, index) => (
            <BundleCard
              key={index}
              bundle={bundle}
              raised={selectedBundle === index}
              onClick={() => handleSelectBundle(index)}
            />
          ))}
        </Container>
      }
      <p></p>
      {props.isError &&
        <Grid container direction="row" alignItems="center" justifyContent="center" spacing="2px">
          <Grid item>
            <ErrorIcon color="error" fontSize="small" />
          </Grid>
          <Grid item>
            <Typography variant="caption" color="error">{props.errorMessage}</Typography>
          </Grid>
        </Grid>
      }
      <p></p>
      <div>
        <Button
          variant="contained"
          disabled={selectedBundle === -1}
          onClick={handleNextStep}
          sx={{ mt: 1, mr: 1 }}
        >
          Continue
        </Button>
        <Button
          variant="outlined"
          disabled={false}
          onClick={props.handleBackStep}
          sx={{ mt: 1, mr: 1 }}
        >
          Back
        </Button>
      </div>
      <Dialog
        open={isPaymentDialogOpen.value}
        TransitionComponent={Transition}
        keepMounted
        onClose={handlePaymentDialogClose}
      >
        <DialogTitle>Check Out</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", margin: "8px 0" }}>
            <Box sx={{ flex: 0, marginRight: "24px" }}>
              {(selectedBundle >= 0) &&
                <BundleCard
                  bundle={props.bundles[selectedBundle]}
                  raised={true}
                />
              }
            </Box>
            <Box sx={{ flex: 1, width: "360px" }}>
              <CardElement />
              <TextField
                fullWidth
                variant="outlined"
                label="Name on card"
                value={ nameOnCard.value }
                onChange={ nameOnCard.onChange }
                disabled={ props.isChargingCard }
                sx={{
                  marginTop: "20px",
                  marginBottom: "16px",
                }}
              />
              {props.isError &&
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing="2px">
                  <Grid item>
                    <ErrorIcon color="error" fontSize="small" />
                  </Grid>
                  <Grid item>
                    <Typography variant="caption" color="error">{props.errorMessage}</Typography>
                  </Grid>
                </Grid>
              }
              <p></p>
              <Button
                variant="contained"
                fullWidth
                disabled={
                  !stripe
                  || !elements
                  || !isCardCompleted.value
                  || !nameOnCard.value
                  || props.isChargingCard
                }
                onClick={handleCheckout}
              >
                Check out
                {props.isChargingCard &&
                  <>
                    <span>&nbsp;</span>
                    <CircularProgress color="primary" size={16} />
                  </>
                }
              </Button>
              <Button
                variant="outlined"
                fullWidth
                disabled={ props.isChargingCard }
                onClick={handlePaymentDialogClose}
                sx={{ marginTop: "16px" }}
              >
                Cancel
              </Button>
              <Box sx={{ textAlign: "right", marginTop: "20px" }}>
                <LockIcon />
                <PoweredByStripe src={PoweredByStripeIcon} alt="Powered By Stripe" />
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

const mapState = (state) => {
  const {
    orderId,
    isGettingBundles,
    bundles,
    isSettingBundle,
    selectedBundle,
    isChargingCard,
    order,
    isError,
    errorMessage,
  } = state.cs;
  const { id } = state.visitor;
  return {
    orderId,
    isGettingBundles,
    bundles,
    isSettingBundle,
    selectedBundle,
    isChargingCard,
    order,
    isError,
    errorMessage,
    visitorId: id,
  };
};

const actionCreators = {
  unsetEmail: csActions.unsetEmail,
  getBundles: csActions.getBundles,
  setBundle: csActions.setBundle,
  chargeCard: csActions.chargeCard,
};

export const Step3Content = connect(mapState, actionCreators)(UnconnectedStep3Content);